import { FC } from 'react';

import { useTranslation } from 'react-i18next';
import { UserName } from 'features/UserCard';
import { NEW_DEFAULT_DATE_FORMAT_UI } from 'shared/config';
import { convertDayJsToString, convertToDayJs } from 'shared/lib/dayjs';

import { LinkButton } from 'shared/ui/LinkButton';
import styles from './AssignmentListItem.module.scss';

export interface ICollapsibleFieldProps {
  username: string;
  startDate: string;
  endDate: string;
  involvement: number | string;
  editLinkHref: string;
  userId: string;
  hideEditButton?: boolean;
}

const AssignmentsListItem: FC<ICollapsibleFieldProps> = ({
  username,
  startDate,
  endDate,
  involvement,
  editLinkHref,
  userId,
  hideEditButton,
}) => {
  const { t } = useTranslation('Assignment');

  const startDateDayJs = convertDayJsToString(convertToDayJs(startDate), NEW_DEFAULT_DATE_FORMAT_UI);
  const endDateDayJs = convertDayJsToString(convertToDayJs(endDate), NEW_DEFAULT_DATE_FORMAT_UI);
  const dates = [startDateDayJs, endDateDayJs].join(' \u2014 ');

  return (
    <div className={styles.rowContainer} data-testid="inner-list-row">
      <div className={styles.name}>
        <UserName name={username} id={userId} />
      </div>
      <span data-testid="inner-list-item-dates" className={styles.dates}>
        {dates}
      </span>
      <span data-testid="inner-list-item-involvement" className={styles.involvement}>{`${involvement}%`}</span>
      {!hideEditButton && (
        <LinkButton
          buttonProps={{ variant: 'outlined' }}
          linkProps={{ to: editLinkHref, className: styles.editButton }}
        >
          {t('Assignment:AssignmentList.item.editButton.label')}
        </LinkButton>
      )}
    </div>
  );
};

export default AssignmentsListItem;
